import type {Backend} from '../api';
import {Dialog} from '../ui/Dialog';
import {Attachments} from './Attachments';
import {EstimateVersions} from './EstimateVersions';

export function DocumentHistoryDialog({backend,sourceId,ticketNumber,title,documentType='ESTIMATE',open,onClose,onUnauthorized,refresh=0}:{backend:Backend;sourceId:string;ticketNumber?:string;title:string;documentType?:string;open:boolean;onClose:()=>void;onUnauthorized:()=>void;refresh?:number}){
 return <Dialog open={open} size="wide" title={`Документы заявки: ${title}`} onClose={onClose}>
  <div className="document-history" key={`${sourceId}:${documentType}`}>
   {backend.documentVersions&&<EstimateVersions backend={backend} sourceId={sourceId} ticketNumber={ticketNumber} documentType={documentType} refresh={refresh} onUnauthorized={onUnauthorized}/>}
   {backend.attachments&&<Attachments backend={backend} recordType="TICKET" recordId={sourceId} onUnauthorized={onUnauthorized}/>}
  </div>
 </Dialog>;
}
